import React from 'react';
import {fetchUtils, AutocompleteArrayInput, ReferenceArrayInput, SelectInput, Button, TabbedForm, FormTab, Filter, BooleanInput, required, Toolbar, SaveButton, 
	DateField, Edit, Create, List, Datagrid, TextField, TextInput, DateInput, SelectArrayInput, FormDataConsumer,
	DeleteButton } from 'react-admin';
import DataTable from 'react-data-table-component';
import CloudDownload from '@material-ui/icons/CloudDownload';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';

const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');

const fetch = fetchUtils.fetchJson;
const BASE_URL = window.nobid_endpoint + '/clicks_report';

const choicesInterval = [
	{ id: 'hour', name: 'Hourly' },
	{ id: 'day', name: 'Daily' },
	{ id: 'week', name: 'Weekly' },
	{ id: 'month', name: 'Monthly' }
];
const dateRangeChoices = [
	{ id: 0, name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
	{ id: 30, name: 'Last 30 Days' },
	{ id: 'custom', name: 'Custom' }
];
// Advertisers see a strict subset. The real boundary is server-side in
// service/reporter/misc_reports.js, which strips these from both the SELECT and
// the WHERE regardless of what the client sends -- this list only keeps the UI
// from offering checkboxes that would silently do nothing.
const choicesShowAdvertiser = [
	{ id: 'date', name: 'Date' },
	{ id: 'tldomain', name: 'Top Level Domain' },
	{ id: 'campaign', name: 'Campaign' },
	{ id: 'creative', name: 'Creative' },
	{ id: 'device', name: 'Device' },
	{ id: 'browser', name: 'Browser' },
	{ id: 'adsize', name: 'Ad Size' },
	{ id: 'page', name: 'Page URL' },
	{ id: 'country', name: 'Country' },
	{ id: 'city', name: 'City' },
	{ id: 'state', name: 'State' },
	{ id: 'user_ip', name: 'User IP' },
	{ id: 'user_zip', name: 'User ZIP' },
	{ id: 'fraud_ip', name: 'Fraudulent IP' }
];
const choicesShowAdmin = [
	{ id: 'date', name: 'Date' },
	{ id: 'tldomain', name: 'Top Level Domain' },
	{ id: 'publisher', name: 'Publisher' },
	{ id: 'site', name: 'Site' },
	{ id: 'bidder', name: 'Bidder' },
	{ id: 'advertiser', name: 'Advertiser' },
	{ id: 'campaign', name: 'Campaign' },
	{ id: 'creative', name: 'Creative' },
	{ id: 'device', name: 'Device' },
	{ id: 'browser', name: 'Browser' },
	{ id: 'adsize', name: 'Ad Size' },
	{ id: 'divid', name: 'Div ID' },
	{ id: 'page', name: 'Page URL' },
	{ id: 'country', name: 'Country' },
	{ id: 'city', name: 'City' },
	{ id: 'state', name: 'State' },
	{ id: 'user_ip', name: 'User IP' },
	{ id: 'user_zip', name: 'User ZIP' },
	{ id: 'fraud_ip', name: 'Fraudulent IP' },
  { id: 'ip_source', name: 'IP Source'}
];
const choicesShow = (permissions) =>
	(permissions && permissions.role === 'advertiser') ? choicesShowAdvertiser : choicesShowAdmin;
const ClicksTitle = ({ record }) => {
	return <span>Clicks Report {record ? `"${record.name}"` : ''}</span>;
};
const ClicksFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
        {/* <BooleanInput source="owned" defaultValue='true' label="Owned By Me" style={{ color: 'white' }} resettable /> */}
    </Filter>
);
export const ClicksList = (props) => (
	<List {...props} title="Clicks Reports" perPage={25} bulkActionButtons={false} filters={<ClicksFilter />} 
	exporter={false} >
		<Datagrid rowClick="edit">
			<TextField source="name" label="Name" />
			<DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
			<DeleteWithConfirmation {...props}/>
		</Datagrid>
	</List>
);
class CustomToolbar extends React.Component {
	state = {
	}
	constructor(props) {
		super(props);
		this.parent = props.parent;
	}
	fetchData() {
		let show='';
		if (formData.show) formData.show.map(item => { show+='&show='+item; });
		let interval = (formData.interval)?`&interval=${formData.interval}`:'&interval=day';
		let dateRange = '';
		if ('custom'===formData.date_range) {
			dateRange = `&start_date=${formData.start_date}&end_date=${formData.end_date}`;
		} else {
			dateRange = `&date_range=${formData.date_range}`;
		}

		this.parent.setState({loading: true, total: '---'});
		let url = `${BASE_URL}?r=1${show}${interval}${dateRange}`+
		`${utils.formDataFieldsQueryStringFormat(formData, ['campaign_id', 'creative_id', 'tldomain', 'device', 'device', 'adsize', 
		'fraud_ip', 'ip_source'])}`;
		let options = { headers: new Headers() };
		options.headers.set('accept', 'application/json');
		const token = localStorage.getItem('token');
		options.headers.set('Authorization', `Bearer ${token}`);
		fetch(url, options).then(({ headers, json }) => (
			this.parent.setState({data: json.data, loading: false, total: json.total})
		));
	}
	handleSearch = (props) => {
		this.fetchData();
	}
	render() {
		return <Toolbar>
			<SaveButton style={{marginRight: '10px'}} variant='contained' 
				color='primary' disabled={this.props.parent.state.loading} {...this.props}/>
			<br />
			<Button label='Run Report' onClick={this.handleSearch} props={this} variant='contained' color='primary' 
				startIcon={<RunReportIcon />} style={{padding: '7px', width: '160px'}} 
				disabled={this.props.parent.state.loading} />
			<br />
			<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
			<TextField source="updated_name" label="" style={{ padding: '10px' }} />
		</Toolbar>
	}
};
let formData = {};
function setFormData(formdata) {
	formData = formdata;
}
class ClicksForm extends React.Component {
	state = {};
	render() {
		return (
			<TabbedForm toolbar={<CustomToolbar parent={this.props.parent} />} redirect='edit' {...this.props}>
			<FormTab label="Report Settings">
				<TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
				<FormDataConsumer>
					{({ formData }) => setFormData(formData) }
				</FormDataConsumer>
				<div style={{ width: '100%', overflow: 'hidden' }} id="wrapper2">
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectInput label="Interval" source="interval"
						choices={choicesInterval}
						defaultValue='day'
						disabled={this.props.parent.loading} />
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectInput label="Date Range" source="date_range"
						choices={dateRangeChoices}
						onChange={value => this.setState({ date_range: value.target.value })}
						defaultValue="8"
						disabled={this.props.parent.loading} />

						<div style={{ float: 'right', paddingLeft: '5px', display: ('custom' != this.state.date_range) ? 'none' : 'block' }}>
						<div style={{ float: 'left', paddingRight: '5px', display: ('custom' != this.state.date_range) ? 'none' : 'block' }}>
							<DateInput label="Start Date" source="start_date" allowEmpty
							disabled={this.props.parent.loading}
							style={{ display: ('custom' != this.state.date_range) ? 'none' : 'block' }} />
						</div>

						<div style={{ float: 'left', display: ('custom' != this.state.date_range) ? 'none' : 'block' }}>
							<DateInput label="End Date" source="end_date" allowEmpty
							disabled={this.props.parent.loading}
							style={{ display: ('custom' != this.state.date_range) ? 'none' : 'block' }} />
						</div>
						</div>
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectArrayInput label="Show"
						source="show"
						choices={choicesShow(this.props.parent.props.permissions)}
						defaultValue={['fraud_ip']}
						style={{ width: '400px' }}
						disabled={this.props.parent.loading} />
					</div>
				</div>
				<div style={{ width: '100%', overflow: 'hidden' }} id="wrapper3">
					<div style={{ float: 'left', paddingRight: '10px' }}>
					<TextInput source="tldomain" label="Domain / App" style={{ width: '400px' }} />
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
					<SelectInput label="Select Fraud Type" 
					source="fraud_ip" 
					choices={[
						{ id: 'false', name: 'Non Fraud IP Only' },
						{ id: 'true', name: 'Fraud IP Only' },
						{ id: '', name: 'Both' },
					]} 
					defaultValue='false' />
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
					<ReferenceArrayInput label="Campaign"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ type:'DIRECT', search_name: searchText })}
						source="campaign_id"
						reference="adcampaigns"
						basePath='adcampaigns'>
						<AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""} 
						optionValue='code' style={{ width: '200px' }}/>
          </ReferenceArrayInput>
					</div>
					{/* campaign_id, creative_id, device, adsize, fraud_ip */}
				</div>
			</FormTab>
			</TabbedForm>
		)
	}
}
let BASE_COLUMNS = [
	{ name: 'Date', selector: 'date', sortable: true, cell: row => ('' + row.date) },
	{ name: 'Domain', selector: 'tldomain', sortable: true },
	{ name: 'Page URL', selector: 'page', sortable: true },
	{ name: 'Publisher ID', selector: 'publisher_id', sortable: true },
	{ name: 'Publisher Name', selector: 'publisher_name', sortable: true },
	{ name: 'Site ID', selector: 'site_id', sortable: true },
	{ name: 'Site Name', selector: 'site_name', sortable: true },
	{ name: 'Bidder ID', selector: 'bidder_id', sortable: true },
	{ name: 'Bidder Name', selector: 'bidder_name', sortable: true },
	{ name: 'Advertiser ID', selector: 'advertiser_id', sortable: true },
	{ name: 'Advertiser Name', selector: 'advertiser_name', sortable: true },
	{ name: 'Campaign ID', selector: 'campaign_id', sortable: true },
	{ name: 'Campaign Name', selector: 'campaign_name', sortable: true },
	{ name: 'Creative ID', selector: 'creative_id', sortable: true },
	{ name: 'Creative Name', selector: 'creative_name', sortable: true },
	{ name: 'Device', selector: 'device', sortable: true },
	{ name: 'Browser', selector: 'browser', sortable: true },
	{ name: 'Ad Size', selector: 'adsize', sortable: true },
	{ name: 'Div ID', selector: 'divid', sortable: true },
	{ name: 'Country', selector: 'country', sortable: true },
	{ name: 'City', selector: 'city', sortable: true },
	{ name: 'State', selector: 'state', sortable: true },
	{ name: 'User Zip', selector: 'user_zip', sortable: true },
	{ name: 'User IP', selector: 'user_ip', sortable: true },
	{ name: 'Fraudulent IP', selector: 'fraud_ip', sortable: true, cell: row => <span>{ ''+row.fraud_ip }</span> },
  { name: 'IP Source', selector: 'ip_source', sortable: true },
	{ name: 'Clicks', selector: 'total', sortable: true, cell: row => utils.formatLong(row.total) },
	{ name: '$ Spend', selector: 'spend', sortable: true, cell: row => utils.formatDouble(row.spend) }
];
let columns = [];
class ClicksUpsert extends React.Component {
	state = {
		data: [],
		loading: false,
		total: '---'
	};
	constructor(props) {
		super(props);
	}
	setState(obj) {
		if (obj.data && obj.data.length>0) {
			let keys = Object.keys(obj.data[0]);
			columns = BASE_COLUMNS.filter( item => { return keys.includes(item.selector) } );
		}
		super.setState(obj);
	}
	render(props) {
		const { data, loading, total } = this.state;
		return (
		<div>
			{this.props.formType === "edit" &&
				<Edit title={<ClicksTitle />} {...this.props}>
					<ClicksForm formType="edit" parent={this}/>
				</Edit>
			}
			{this.props.formType === "create" &&
				<Create title="Create Clicks Report" {...this.props}>
					<ClicksForm formType="create" parent={this}/>
				</Create>
			}
			<DataTable
				title={`${total} Matching Results`}
				theme={window.nobid_table_theme()}
				columns={columns}
				data={data}
				progressPending={loading}
				pagination
				fixedHeader
				dense
				paginationPerPage={30}
				paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
				subHeader={!loading}
				subHeaderComponent={
					(
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<input type="text" id='search_box' label="Search"
						variant="outlined"
						style={{ margin: '5px' }}
						onChange={(target) => dataSupport.filterData(this)} />
						<CloudDownload
						label="Export"
						style={{ margin: '5px' }}
						color="action"
						onClick={() => dataSupport.exportData(this.state.data)}
						/>
					</div>
					)
				}
			/>
		</div>
		)
	}
}

export const ClicksEdit = (props) => (
	<ClicksUpsert formType="edit" permissions={props.permissions} {...props} />
);

export const ClicksCreate = (props) => (
	<ClicksUpsert formType="create" permissions={props.permissions} {...props} />
);